<template>
  <AppSpacer v-if="blok.size" :size="blok.size" />
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{ blok: MarketingSpacerBlokStoryblok }>();
</script>
